import { render, staticRenderFns } from "./setGift.vue?vue&type=template&id=d551bc34&scoped=true&"
import script from "./setGift.vue?vue&type=script&lang=js&"
export * from "./setGift.vue?vue&type=script&lang=js&"
import style0 from "./setGift.vue?vue&type=style&index=0&id=d551bc34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d551bc34",
  null
  
)

export default component.exports